import cx from 'classnames';
import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import { useUpdateEffect } from 'react-use';
import { FadeTransition, ScaleTransition, SlideTransition } from '@bcz/react-transition';
import { useVisibleTransition, useScrollLock } from './hooks';
import { getPortalContainer, callBoth } from './_util';
import styles from './Modal.module.less';
export function Modal(_a) {
    var children = _a.children, visible = _a.visible, _b = _a.effect, effect = _b === void 0 ? 'scale' : _b, _c = _a.popup, popup = _c === void 0 ? false : _c, onClose = _a.onClose, onExited = _a.onExited, _d = _a.maskClosable, maskClosable = _d === void 0 ? false : _d, _e = _a.destroyOnClose, destroyOnClose = _e === void 0 ? true : _e, className = _a.className;
    if (popup) {
        effect = 'slide';
    }
    var _f = useVisibleTransition(visible), contentIn = _f.contentIn, shouldContentEnter = _f.shouldContentEnter, shouldContentRender = _f.shouldContentRender, onContentExit = _f.onContentExit;
    var container = React.createElement("div", { className: styles.modalContainer }, children);
    var portalContainer = useMemo(function () { return getPortalContainer(); }, []);
    var toggleLocked = useScrollLock().toggleLocked;
    useUpdateEffect(function () {
        toggleLocked(visible);
    }, [visible]);
    if (!shouldContentRender && destroyOnClose) {
        return null;
    }
    return createPortal(React.createElement("div", { className: cx(styles.modalRoot, className), style: { display: !destroyOnClose && !contentIn ? 'none' : undefined } },
        React.createElement(FadeTransition, { in: shouldContentEnter },
            React.createElement("div", { className: styles.modalBackdrop, onClick: function () {
                    if (maskClosable && onClose) {
                        onClose();
                    }
                } })),
        effect === 'scale' && (React.createElement(ScaleTransition, { in: shouldContentEnter, unmountOnExit: destroyOnClose, onExited: callBoth(onExited, onContentExit) }, container)),
        effect === 'slide' && (React.createElement(SlideTransition, { in: shouldContentEnter, unmountOnExit: destroyOnClose, onExited: callBoth(onExited, onContentExit), from: popup ? [0, window.innerHeight] : undefined }, container))), portalContainer);
}
